import { routes } from '@/router';
import router from '@/router';
import store from '@/store';
import $common from './common-utils';
import { dateFormatter, getCalendar, momentFormatter } from '@/libs/date-utils';

export function goPage(name, params = {}, replace = false) {
    if (name == -1) {
        router.back();
        // budo_log.info("#10", router);
        // budo_log.info("#11", router.history);
        // let pending = router.history.pending;
        // if (pending) {
        //     router.push({
        //         path: pending.fullPath
        //     });
        // }
        return;
    }
    let toPageArr = routes.filter((item) => item.name === name);
    if (toPageArr && toPageArr.length > 0) {
        let toPage = toPageArr[0];
        if (!replace) {
            router.push({
                path: toPage.path,
                query: params
            })
        } else {
            router.replace({
                path: toPage.path,
                query: params
            })
        }
    }
}

export default {
    install(Vue) {
        Vue.prototype.$goPage = goPage;

            Vue.prototype.$common = $common;

        Vue.prototype.$dateFormatter = dateFormatter;
        Vue.prototype.$momentFormatter = momentFormatter;
        Vue.prototype.$getCalendar = getCalendar;
        Vue.prototype.$documentTitle = (title) => {
            document.title = title;
            store.commit('setTitle', title);
        }
    }
}